import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { HomeService } from 'src/app/services/home.service';
import { Setting } from 'src/app/models/setting.model';
import { getLocalTranslate } from 'src/app/helpers/global-functions'
import { from } from 'rxjs';
import { applySourceSpanToExpressionIfNeeded } from '@angular/compiler/src/output/output_ast';
import { Router } from '@angular/router';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.css']
})
export class DefaultComponent implements OnInit {

  isLoggedIn = false
  isCheckedAuth = false

  call:string = 'Call'
  followUs:string = 'Follow Us'
  myAccount:string = 'My Account'
  login:string = 'Login'
  register:string = 'Register'

  isTeacher:boolean = false

  flagImage:string = 'assets/img/us-flag.jpg'

  setting: Setting = new Setting()

  constructor(
    private authService: AuthService,
    private homeService: HomeService,
    private router:Router
  ) { }

  ngOnInit() {
    const userType = localStorage.getItem('user-type')
    console.log("UserType",userType)
    this.isTeacher = userType === '1'? false : true
    console.log("Teacher",this.isTeacher)
    const defaultLanguage = localStorage.getItem('camedu-language')
    this.flagImage = defaultLanguage === 'EN' || undefined ? 'assets/img/kh-flag.png' : 'assets/img/us-flag.jpg'
    this.checkAuth()
    this.getSetting()
    this.getTranslate()
  }

  getSetting() {
    this.homeService.getSetting().then(result => {
      this.setting = result as Setting
      localStorage.setItem('local-setting', JSON.stringify(result))
    })
  }

  async checkAuth() {
    this.isCheckedAuth = false
    let isLoggedIn = await this.authService.checkAuth()
    this.isCheckedAuth = true
    this.isLoggedIn = isLoggedIn !== null
    console.log("Is Logged-In:",this.isLoggedIn)
  }

  getTranslate() {
    this.homeService.getTranslate().then(result => {
      localStorage.setItem('local-translate', JSON.stringify(result))
      this.call = getLocalTranslate('call',this.call)
      this.followUs = getLocalTranslate('follow-us',this.followUs)
      this.myAccount = getLocalTranslate('my-account',this.myAccount)
      this.login = getLocalTranslate('login',this.login)
      this.register = getLocalTranslate('register',this.register)
    })
  }

  onActivate(event) {
    window.scroll(0, 0);
  }

  onSwitchLanguage(){
    const defaultLanguage = localStorage.getItem('camedu-language')
    var currentLanguage:string = ''
    if(!defaultLanguage){
      currentLanguage = 'EN'
    }else{
      currentLanguage = defaultLanguage === 'EN' ? 'KH' : 'EN'
    }
    console.log(currentLanguage)
    localStorage.setItem('camedu-language', currentLanguage)
    window.location.reload()
  }

  goMyAccount(){
    const myAccountUrl = this.isTeacher? '/my-account/teacher-comments' : '/my-account/courses'
    this.router.navigate([myAccountUrl])
  }



}
